import React from 'react';
import './AppTile.scss';

function AppTile({ url, name, description, index, enabled, onClick }) {
  const handleClick = () => {
    if (!enabled) return;
    if (onClick) {
      onClick();
    } else if (url) {
      window.open(url, '_blank');
    }
  };

  return (
    <div
      className={`app-tile ${enabled ? '' : 'disabled'}`}
      onClick={handleClick}
      role="link"
      tabIndex={index}
    >
      <div className={`app-tile-body ${enabled ? '' : 'disabled'}`}>
        <p>{name}</p>
      </div>
      <div className="app-tile-footer">
        <p>{description}</p>
      </div>
    </div>
  );
}

export default AppTile;
